import type { FichaSecaoProps } from "./types-ficha-secao";

/**
 * Decide o corpo da seção e as ações do topo: Exportar e E-mail só na Identificação da ficha salva;
 * Anexos da prévia ficam em memória e vão com o Salvar; o detalhamento da ficha salva só lista.
 */
export function useFichaSecao({
  section,
  acoes,
  semAcoesTopo = false,
  anexosDe,
  anexosPrevia,
}: FichaSecaoProps) {
  const anexosDaFicha = section.kind === "anexos" && anexosDe ? anexosDe : null;
  const anexosDaPrevia =
    section.kind === "anexos" && !anexosDe && anexosPrevia ? anexosPrevia : null;
  const anexosAguardandoFicha = section.kind === "anexos" && !anexosDe && !anexosPrevia;

  return {
    section,
    tituloId: `ficha-${section.id}-titulo`,
    anexosDaFicha,
    anexosDaPrevia,
    anexosAguardandoFicha,
    acoesTopo: section.id === "identificacao" && !semAcoesTopo ? (acoes ?? null) : null,
    orcamentoEmBreve: section.kind === "orcamento",
    custos: section.kind === "custos",
    campos: section.kind === "campos",
  };
}
